import React, { useCallback, useEffect, useMemo, useRef } from "react";

const DEFAULT_AGENT_URL = "/openbravo-business-operation-agent/";

export const TOKEN_MESSAGE_TYPE = "OPENBRAVO_AGENT_TOKEN";
export const TOKEN_REQUEST_MESSAGE_TYPE = "OPENBRAVO_AGENT_TOKEN_REQUEST";

const getToken = () => sessionStorage.mstoken || localStorage.token;

const OpenbravoAgent = () => {
  const iframeRef = useRef(null);
  const consul = window.config && window.config.consul;
  const src = (consul && consul.BUSINESS_OPERATION_AGENT_URL) || DEFAULT_AGENT_URL;
  const targetOrigin = useMemo(() => new URL(src, window.location.href).origin, [src]);

  const sendToken = useCallback(() => {
    const target = iframeRef.current && iframeRef.current.contentWindow;
    const token = getToken();
    if (!target || !token) return;
    target.postMessage({ type: TOKEN_MESSAGE_TYPE, token }, targetOrigin);
  }, [targetOrigin]);

  // the agent may register its listener after the load event, so it can also ask for the token
  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== targetOrigin) return;
      if (event.source !== (iframeRef.current && iframeRef.current.contentWindow)) return;
      if (event.data && event.data.type === TOKEN_REQUEST_MESSAGE_TYPE) sendToken();
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [targetOrigin, sendToken]);

  return (
    <div className="animated fadeIn" style={{ height: "calc(100vh - 150px)" }}>
      <iframe
        ref={iframeRef}
        src={src}
        title="360 Agent"
        onLoad={sendToken}
        style={{ width: "100%", height: "100%", border: 0 }}
      />
    </div>
  );
};

export default OpenbravoAgent;
